var _defs, _metadata, _g, _rect, _path, _g2, _path2, _g3, _circle, _g4, _circle2, _circle3, _circle4, _circle5, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3783 3061",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str1 {stroke:black;stroke-width:9.7938}\r\n    .str0 {stroke:black;stroke-width:86.3715}\r\n    .str3 {stroke:black;stroke-width:86.3715;stroke-linejoin:round}\r\n    .str2 {stroke:black;stroke-width:86.3715;stroke-linecap:round}\r\n    .fil2 {fill:none}\r\n    .fil5 {fill:black}\r\n    .fil6 {fill:#704123}\r\n    .fil0 {fill:#CB6C28}\r\n    .fil1 {fill:#FCC99A}\r\n    .fil4 {fill:white}\r\n    .fil3 {fill:white;fill-rule:nonzero}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1891 571c-121,-2 -824,25 -1227,894 -489,1054 424,1184 1227,1184 802,-2 1718,-129 1228,-1184 -404,-869 -1106,-896 -1228,-894z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_532767112"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M268 1084c344,320 1111,497 1090,91 -14,-276 -752,-371 -1090,-91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M951 1167c0,0 -218,-142 -501,-62 279,178 416,186 451,198 36,12 50,-136 50,-136z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M3515 1084c-344,320 -1111,497 -1090,91 14,-276 752,-371 1090,-91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M2832 1167c0,0 218,-142 501,-62 -279,178 -416,186 -451,198 -36,12 -50,-136 -50,-136z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    width: 3783,
    height: 3061
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1891 571c-121,-2 -824,25 -1227,894 -489,1054 424,1184 1227,1184 802,-2 1718,-129 1228,-1184 -404,-869 -1106,-896 -1228,-894z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "fil2 str1",
    cx: 57,
    cy: 958,
    rx: 62,
    ry: 130
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M1890 3743c223,0 416,-159 515,-393 53,25 108,39 165,39 343,0 621,-491 621,-1097 0,-606 -278,-1097 -621,-1097 -333,0 -606,465 -620,1049 -19,-3 -39,-4 -60,-4 -20,0 -40,1 -59,4 -14,-584 -287,-1049 -620,-1049 -343,0 -621,491 -621,1097 0,606 278,1097 621,1097 57,0 112,-14 165,-39 99,234 292,393 514,393z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M1891 571c-121,-2 -824,25 -1227,894 -489,1054 424,1184 1227,1184 802,-2 1718,-129 1228,-1184 -404,-869 -1106,-896 -1228,-894z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1666 1777l-172 0 0 0 0 -8 -1 -7 0 -8 -2 -7 -1 -8 -2 -7 -2 -7 -3 -7 -2 -6 -3 -6 -3 -7 -4 -6 -4 -5 -4 -6 -4 -5 -4 -5 -4 -5 -5 -4 -5 -4 -5 -4 -5 -3 -5 -4 -5 -3 -5 -2 -6 -3 -5 -2 -6 -1 -6 -2 -5 -1 -6 -1 -6 0 -6 0 0 -173 15 0 16 2 15 2 15 3 15 3 14 5 14 5 14 6 13 7 13 7 13 8 12 8 11 9 11 10 11 10 10 11 10 11 9 11 8 12 9 13 7 13 7 13 6 13 6 14 5 14 5 15 3 15 4 15 2 15 2 16 1 15 0 16 0 0zm-296 318l0 -173 0 0 6 0 6 -1 6 -1 5 -1 6 -1 6 -2 5 -2 6 -2 5 -3 5 -3 5 -3 5 -4 5 -3 5 -5 5 -4 4 -5 4 -5 4 -5 4 -5 4 -6 4 -6 3 -6 3 -6 2 -7 3 -7 2 -7 2 -7 1 -7 2 -7 0 -8 1 -8 0 -8 172 0 0 16 -1 16 -2 15 -2 16 -4 15 -3 15 -5 14 -5 14 -6 14 -6 14 -7 13 -7 13 -9 12 -8 12 -9 12 -10 11 -10 11 -11 10 -11 9 -11 9 -12 9 -13 8 -13 7 -13 7 -14 5 -14 6 -14 4 -15 4 -15 3 -15 2 -16 1 -15 1 0 0zm-297 -318l172 0 0 0 1 8 0 8 1 8 1 7 2 7 2 7 2 7 2 7 3 7 3 6 3 6 3 6 4 6 4 5 4 5 4 5 5 5 5 4 4 5 5 3 5 4 5 3 6 3 5 3 5 2 6 2 5 2 6 1 6 1 6 1 6 1 6 0 0 173 -16 -1 -15 -1 -15 -2 -15 -3 -15 -4 -15 -4 -14 -6 -13 -5 -14 -7 -13 -7 -12 -8 -12 -9 -12 -9 -11 -9 -10 -10 -11 -11 -9 -11 -9 -12 -9 -12 -8 -12 -8 -13 -6 -13 -7 -14 -5 -14 -6 -14 -4 -14 -4 -15 -3 -15 -3 -16 -1 -15 -1 -16 -1 -16 0 0zm297 -317l0 173 0 0 -6 0 -6 0 -6 1 -6 1 -6 2 -5 1 -6 2 -5 3 -5 2 -6 3 -5 4 -5 3 -5 4 -4 4 -5 4 -5 5 -4 5 -4 5 -4 6 -4 5 -3 6 -3 7 -3 6 -3 6 -2 7 -2 7 -2 7 -2 8 -1 7 -1 8 0 7 -1 8 -172 0 1 -16 1 -15 1 -16 3 -15 3 -15 4 -15 4 -15 6 -14 5 -14 7 -13 6 -13 8 -13 8 -13 9 -12 9 -11 9 -11 11 -11 10 -10 11 -10 12 -9 12 -8 12 -8 13 -7 14 -7 13 -6 14 -5 15 -5 15 -3 15 -3 15 -2 15 -2 16 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M1370 1546c116,0 210,104 210,231 0,128 -94,231 -210,231 -117,0 -211,-103 -211,-231 0,-127 94,-231 211,-231z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 1428,
    cy: 1780,
    r: 191
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M2117 1777l0 0 0 -16 1 -15 2 -16 2 -15 4 -15 3 -15 5 -15 5 -14 6 -14 6 -13 7 -13 7 -13 9 -13 8 -12 9 -11 10 -11 10 -11 11 -10 11 -10 11 -9 12 -8 13 -8 13 -7 13 -7 14 -6 14 -5 14 -5 15 -3 15 -3 15 -2 16 -2 15 0 0 173 -6 0 -6 0 -6 1 -5 1 -6 2 -6 1 -5 2 -6 3 -5 2 -5 3 -5 4 -5 3 -5 4 -5 4 -5 4 -4 5 -4 5 -5 5 -3 6 -4 5 -4 6 -3 7 -3 6 -2 6 -3 7 -2 7 -2 7 -1 8 -2 7 0 8 -1 7 0 8 0 0 -172 0zm296 318l0 0 -15 -1 -16 -1 -15 -2 -15 -3 -15 -4 -14 -4 -14 -6 -14 -5 -13 -7 -13 -7 -13 -8 -12 -9 -11 -9 -11 -9 -11 -10 -10 -11 -10 -11 -9 -12 -8 -12 -9 -12 -7 -13 -7 -13 -6 -14 -6 -14 -5 -14 -5 -14 -3 -15 -4 -15 -2 -16 -2 -15 -1 -16 0 -16 172 0 0 8 1 8 0 8 2 7 1 7 2 7 2 7 3 7 2 7 3 6 3 6 4 6 4 6 3 5 5 5 4 5 4 5 5 4 5 5 5 3 5 4 5 3 5 3 5 3 6 2 5 2 6 2 6 1 5 1 6 1 6 1 6 0 0 0 0 173zm297 -318l0 0 -1 16 -1 16 -1 15 -3 16 -3 15 -4 15 -4 14 -6 14 -5 14 -7 14 -7 13 -7 13 -8 12 -9 12 -9 12 -9 11 -11 11 -10 10 -11 9 -12 9 -12 9 -12 8 -13 7 -14 7 -13 5 -14 6 -15 4 -15 4 -15 3 -15 2 -15 1 -16 1 0 -173 6 0 6 -1 6 -1 6 -1 6 -1 5 -2 6 -2 5 -2 5 -3 6 -3 5 -3 5 -4 5 -3 4 -5 5 -4 5 -5 4 -5 4 -5 4 -5 4 -6 3 -6 3 -6 3 -6 3 -7 2 -7 2 -7 2 -7 2 -7 1 -7 1 -8 0 -8 1 -8 0 0 172 0zm-297 -317l0 0 16 0 15 2 15 2 15 3 15 3 15 5 14 5 13 6 14 7 13 7 12 8 12 8 12 9 11 10 10 10 11 11 9 11 9 11 9 12 8 13 7 13 7 13 7 13 5 14 6 14 4 15 4 15 3 15 3 15 1 16 1 15 1 16 -172 0 -1 -8 0 -7 -1 -8 -1 -7 -2 -8 -2 -7 -2 -7 -2 -7 -3 -6 -3 -6 -3 -7 -3 -6 -4 -5 -4 -6 -4 -5 -4 -5 -5 -5 -5 -4 -4 -4 -5 -4 -5 -3 -5 -4 -6 -3 -5 -2 -5 -3 -6 -2 -5 -1 -6 -2 -6 -1 -6 -1 -6 0 -6 0 0 0 0 -173z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M2413 1546c-116,0 -210,104 -210,231 0,128 94,231 210,231 116,0 211,-103 211,-231 0,-127 -95,-231 -211,-231z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 2355,
    cy: 1780,
    r: 191
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 2298,
    cy: 1779,
    r: 75
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 1485,
    cy: 1779,
    r: 75
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 1891,
    cy: 2240,
    r: 138
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M1890 2240c0,62 5,125 0,186 -6,93 -207,107 -219,-59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M1892 2240c0,62 -4,125 0,186 7,93 208,107 220,-59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil6 str3",
    d: "M810 455c0,71 14,72 16,104 -132,0 -156,-104 -173,-125 -62,-79 -234,-6 -108,161 74,99 186,142 311,142 93,0 212,-41 302,29 81,62 85,181 172,193 49,6 98,-38 98,-85 0,-51 -110,-210 -162,-245 27,-93 83,-68 146,-119 25,-20 35,-61 20,-97 -66,-157 -274,33 -328,146 -21,-8 -94,-19 -108,-19 9,-76 13,-240 -107,-214 -52,12 -79,66 -79,129z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fil6 str3",
    d: "M2973 455c0,71 -14,72 -17,104 133,0 157,-104 174,-125 62,-79 234,-6 108,161 -74,99 -186,142 -311,142 -93,0 -212,-41 -302,29 -81,62 -85,181 -172,193 -49,6 -98,-38 -98,-85 0,-51 110,-210 162,-245 -27,-93 -83,-68 -146,-119 -25,-20 -35,-61 -20,-97 66,-157 274,33 328,146 21,-8 94,-19 108,-19 -9,-76 -13,-240 107,-214 52,12 79,66 79,129z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni18);
export default __webpack_public_path__ + "static/media/ani18.09d06da4eda552705acf5faf9bd71f59.svg";
export { ForwardRef as ReactComponent };